import React from 'react';

interface VerticalTextImageProps {
  imageSrc: string;
  verticalText?: string | null;
  bottomText?: string | React.ReactNode;
  imageTall?: boolean;
}

export const VerticalTextImage: React.FC<VerticalTextImageProps> = ({
  imageSrc,
  verticalText = null,
  bottomText = null,
  imageTall = true,
}) => {
  return (
    <div className="relative w-full overflow-hidden md:flex">
      <div className="md:w-1/2 w-full">
        <img
          src={imageSrc}
          alt="Background"
          className={`w-full object-cover transform ${
            imageTall ? 'h-[800px]' : 'h-[450px]'
          }`}
          data-background-image
        />
      </div>
      <div className="md:w-1/2 w-full flex flex-col justify-center items-center md:relative md:text-black text-white md:bg-transparent bg-black md:py-0">
        {bottomText && (
          <div className="flex justify-center">
            <div className="hidden md:block text-start text-lg">
              <p>
                Apartment Hotel
                <br />
                For Neighborhood Stay
              </p>
            </div>
          </div>
        )}
        {verticalText && (
          <>
            {/* SP時の縦書きテキスト */}
            <div className="block md:hidden absolute left-1 top-1/2 transform -translate-y-1/2 rotate-90">
              <p className="text-white text-[20px]">{verticalText}</p>
            </div>
            {/* PC時の縦書きテキスト */}
            <div className="hidden md:block absolute top-1/2 right-0 transform -translate-y-1/2 md:-translate-x-1/2">
              <p
                className="text-black text-lg"
                style={{ writingMode: 'vertical-rl' }}
              >
                {verticalText}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
